import type React from 'react';
import type { ComponentType, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from './context/Session';

export interface RolesProps {
  authorizedRoles: string[];
  defaultAction?: () => React.JSX.Element | ReactNode | null;
}

const bounceToLandingPage = () => <Navigate to="/" replace />;

export const withRole =
  (props: RolesProps) =>
  <T extends object>(WrappedComponent: ComponentType<T>) => {
    return (innerProps: T) => {
      const { userInfo } = useSession();
      const isAuthorized =
        userInfo?.roleType &&
        props.authorizedRoles?.map(r => r.toLowerCase()).includes(userInfo.roleType.toLowerCase());
      if (!isAuthorized) {
        const nextAction = props.defaultAction ?? bounceToLandingPage;

        return nextAction();
      }
      return <WrappedComponent {...innerProps} />;
    };
  };
